import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto mb-5 max-w-[1366px] lg:mb-12',
    wrapper: 'relative overflow-hidden',
    video: 'block h-auto w-full',
    playButton:
      'flex-center absolute top-1/2 left-1/2 z-1 size-16 -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full bg-white/80 transition-colors hover:bg-white md:size-[66px]',
    playIcon: 'ml-0.5 h-[18px] w-auto text-black [&_path]:fill-current'
  }
});
